.event-tabs {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 2rem;
}

.event-tabs .btn {
  padding: 0.75rem 2rem;
  border-radius: 9999px;
  font-weight: 600;
  font-size: 1.1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 2px solid var(--primary-blue);
}

.event-tabs .btn-primary {
  background-color: var(--primary-blue);
  color: white;
  box-shadow: var(--shadow-md);
}

.event-tabs .btn-outline {
  background-color: transparent;
  color: var(--secondary-gold);
  border-color: var(--secondary-gold);
}

.event-tabs .btn-outline:hover {
  background-color: rgba(212, 175, 55, 0.1);
}

.gallery-filters {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 3rem;
}

.filter-btn {
  padding: 0.5rem 1.5rem;
  border-radius: 9999px;
  border: 1px solid var(--border-color);
  background-color: var(--surface-color);
  color: var(--text-secondary);
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: inherit;
}

.filter-btn:hover {
  border-color: var(--primary-blue);
  color: var(--primary-blue);
}

.filter-btn.active {
  background-color: var(--primary-blue-light);
  color: white;
  border-color: var(--primary-blue-light);
}

.gallery-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 2rem;
}

.gallery-item {
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  background-color: var(--glass-bg);
  border-radius: 12px;
  border: var(--glass-border);
}

.gallery-item:hover {
  transform: translateY(-5px);
  box-shadow: var(--shadow-lg), var(--glow-cyan);
}

.gallery-image-container {
  width: 100%;
  aspect-ratio: 4/3;
  position: relative;
  overflow: hidden;
  background-color: rgba(0,0,0,0.1);
}

.gallery-image-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.gallery-item:hover .gallery-image-container img {
  transform: scale(1.05);
}

.gallery-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(10, 22, 40, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.gallery-item:hover .gallery-overlay {
  opacity: 1;
}

.gallery-icon-hover {
  color: white;
  transform: scale(0.5);
  transition: transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.gallery-item:hover .gallery-icon-hover {
  transform: scale(1);
}

.gallery-caption {
  padding: 1.5rem;
  text-align: center;
}

.gallery-caption h4 {
  margin: 0;
  color: var(--text-primary);
  font-size: 1.1rem;
}

@media (max-width: 768px) {
  .gallery-grid {
    gap: 1.5rem;
  }
}

.lightbox-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100svh;
  background: rgba(0, 0, 0, 0.9);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease;
}
.lightbox-overlay.active {
  opacity: 1;
  pointer-events: all;
}
.lightbox-content {
  position: relative;
  max-width: 90vw;
  max-height: 90svh;
}
.lightbox-image {
  max-width: 100%;
  max-height: 90svh;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
}
.lightbox-close {
  position: absolute;
  top: -40px;
  right: 0;
  color: white;
  background: none;
  border: none;
  font-size: 2rem;
  cursor: pointer;
  transition: color 0.2s ease;
}
.lightbox-close:hover {
  color: var(--primary-cyan);
}
